class SCPartComponents extends HTMLElement {
  connectedCallback() {
    if (this._scInit) return;
    this._scInit = true;

    this.linkProducts = this.dataset.linkProducts !== 'false';
    this.showQuantity = this.dataset.showQuantity !== 'false';
    this.items = Array.from(this.querySelectorAll('[data-sc-sku]'));

    if (!this.items.length) return;

    this.hydrate();
  }

  async hydrate() {
    await Promise.all(this.items.map((item) => this.hydrateItem(item)));
  }

  async hydrateItem(item) {
    const sku = (item.dataset.scSku || '').trim();
    const qty = (item.dataset.scQty || '').trim();
    const fallbackTitle = (item.dataset.scTitle || '').trim();

    let product = null;
    let variant = null;

    if (sku) {
      try {
        const result = await this.fetchProductBySku(sku);
        product = result.product;
        variant = result.variant;
      } catch (err) {
        console.warn('SC PartComponents: SKU lookup failed', sku, err);
      }
    }

    const title = product?.title || fallbackTitle || sku;
    const image =
      variant?.featured_image?.src ||
      product?.featured_image ||
      product?.images?.[0] ||
      null;
    const url = product?.url || (product?.handle ? `/products/${product.handle}` : null);

    item.classList.remove('sc-part-components__item--loading');
    item.innerHTML = '';

    const card = document.createElement(this.linkProducts && url ? 'a' : 'div');
    card.className = 'sc-part-components__card';
    if (this.linkProducts && url) {
      card.href = url;
    }

    const media = document.createElement('div');
    media.className = 'sc-part-components__media';

    if (image) {
      const img = document.createElement('img');
      img.src = this.imageUrl(image, 360);
      img.alt = title;
      img.width = 180;
      img.height = 180;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'sc-part-components__placeholder';
      media.appendChild(placeholder);
    }

    const body = document.createElement('div');
    body.className = 'sc-part-components__body';

    const titleEl = document.createElement('span');
    titleEl.className = 'sc-part-components__title';
    titleEl.textContent = title;
    body.appendChild(titleEl);

    if (this.showQuantity && qty !== '') {
      const qtyEl = document.createElement('span');
      qtyEl.className = 'sc-part-components__qty';
      qtyEl.textContent = `× ${qty}`;
      body.appendChild(qtyEl);
    }

    card.appendChild(media);
    card.appendChild(body);
    item.appendChild(card);
  }

  imageUrl(src, width) {
    if (!src) return '';
    if (typeof src !== 'string') return '';
    if (src.includes('cdn.shopify.com') && !src.includes('width=')) {
      return src.includes('?') ? `${src}&width=${width}` : `${src}?width=${width}`;
    }
    return src;
  }

  async fetchProductBySku(sku) {
    const searchUrl = `/search/suggest.json?q=${encodeURIComponent(
      sku
    )}&resources[type]=product&resources[options][fields]=variants.sku,title&resources[limit]=5`;

    const res = await fetch(searchUrl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) return { product: null, variant: null };

    const data = await res.json();
    const products = data?.resources?.results?.products || [];
    if (!products.length) return { product: null, variant: null };

    const skuLower = sku.toLowerCase();

    for (const preview of products) {
      if (!preview?.handle) continue;

      const productRes = await fetch(`/products/${preview.handle}.js`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!productRes.ok) continue;

      const fullProduct = await productRes.json();
      const matchedVariant = (fullProduct.variants || []).find((v) => {
        return (v.sku || '').toLowerCase() === skuLower;
      });

      if (matchedVariant) {
        return { product: fullProduct, variant: matchedVariant };
      }
    }

    // No exact SKU match — keep fallback title from metafield
    return { product: null, variant: null };
  }
}

if (!customElements.get('sc-part-components')) {
  customElements.define('sc-part-components', SCPartComponents);
}
